<template>
    <div class="fullscreen text-center py-5">
        <Logo width="60" class="mt-5" logomark v-if="showLogo" />
        <h1 class="mt-5">{{ title }}</h1>
        <p>{{ description }}</p>
        <div class="mt-5" v-if="showButton">
            <Button color="light" @click="back">{{ backBtnText ? backBtnText : $t('errorPage.back') }}</Button>
        </div>
    </div>
</template>

<script>
    import Logo from '../Logo'
    import Button from '../Button'

    export default {
        name: 'ErrorPage',
        props: {
            title: {
                type: String,
                required: true
            },
            description: {
                type: String,
                required: true
            },
            showLogo: {
                type: Boolean,
                default: true
            },
            showButton: {
                type: Boolean,
                default: true
            },
            backBtnText: String
        },
        components: {
            Logo,
            Button
        },
        methods: {
            back() {
                if (this.hasBackListener) {
                    this.$emit('back')
                }
                else {
                    window.location.href = 'https://hexeko.com'
                }
            }
        },
        computed:{
            hasBackListener(){
                return this.$listeners && this.$listeners.back
            }
        }
    }
</script>
